<template>
  <v-container class="no-margins">
    <!-- component title -->
    <template v-if="type == 'instructor'">
      <div class="title-icon top">
        <h1>{{ $t("labels.instructor") }}</h1>
        <v-btn icon :href="links.main.bynInstructors" target="_blank">
          <v-icon>$sl-question</v-icon>
        </v-btn>
      </div>
      <p>{{ $t("company.instructor-text") }}</p>
      <!-- <a :href="links.main.bynInstructors" target="_blank">{{
        $t("company.instructor-text-link")
      }}</a> -->

      <MessageBox class="my-5" type="info" :closable="true">
        <h6>{{ $t("company.instructor-info-title") }}</h6>
        <p>
          {{ $t("company.instructor-info-text1") }}
          <!-- <router-link :to="{ name: 'CompanyExemptions', id: $route.params.id }"> -->
          {{
            $t("company.instructor-info-text1-link")
          }}
          <!-- </router-link> -->
          {{ $t("company.instructor-info-text1-1") }}
        </p>
        <p>{{ $t("company.instructor-info-text2") }}</p>
        <p>
          {{ $t("company.instructor-info-text3") }}
          <!-- <a :href="links.main.bynMachineInfo"> -->
          {{
            $t("company.instructor-info-text3-link")
          }}
          <!-- </a> -->
          {{ $t("company.instructor-info-text3-1") }}
          <!-- <a :href="links.main.bynMachineInfo"> -->
          {{ $t("company.instructor-info-text3-link2") }}
          <!-- </a> -->
          {{ $t("company.instructor-info-text3-2") }}
        </p>

        <p>
          {{ $t("company.instructor-info-text4") }}
          <a :href="links.main.bynInstructorInstructions" target="_blank">{{
            $t("company.instructor-info-text4-link")
          }}</a
          >.
        </p>
        <p>
          {{ $t("company.instructor-info-text5") }}  
            {{ $t("company.instructor-info-text5-link") }}  
          {{ $t("company.instructor-info-text5-1") }}
        </p>
      </MessageBox>
      <!-- <MessageBox class="my-5" type="info" :closable="true">
        <h6>{{ $t("company.instructor-info-title2") }}</h6>
      </MessageBox> -->
    </template>
    <h1 v-else-if="title" v-html="title"></h1>
    <h1 v-else>{{ title ? title : $t("labels.staff") }}</h1>

    <v-text-field
      class="search-field mb-6 mt-5"
      prepend-icon="$sl-search"
      single-line
      hide-details
      :label="$t('application.alt-search-label')"
      @input="fetchListData"
      v-model="search"
    ></v-text-field>

    <v-chip v-if="workplaceChip" label close @click:close="closeWorkplaceChip()">{{
      workplaceLabel
    }}</v-chip>
    <!-- used to display list of employees -->
    <template v-if="isDepartments">
      <MessageBox
        v-if="!isAdministrator && MessageBoxText != ''"
        class="my-5"
        type="info"
      >
        <p>{{ MessageBoxText }}</p>
      </MessageBox>
      <v-tabs
        v-model="tab"
        :fixed-tabs="$vuetify.breakpoint.xsOnly"
        :centered="$vuetify.breakpoint.xsOnly"
      >
        <v-tab key="1">{{ $t("labels.all") }}</v-tab>
        <v-tab key="2">{{ $t("company.sections") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="1">
          <CompanyEmployeeListItems
            :nextTo="nextTo"
            :nextIcon="nextIcon"
            :type="type"
            :emp="employees"
          ></CompanyEmployeeListItems>
        </v-tab-item>
        <v-tab-item key="2">
        <MessageBox        
        class="mb-6"
        type="info"
      >
        <p>{{ $t("company.employees-mb-text") }}</p>
      </MessageBox>
          <CompanyEmployeeListDepartments
            :nextTo="nextTo"
            :nextIcon="nextIcon"
            :type="type"
            :emp="employees"
          ></CompanyEmployeeListDepartments>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-else>
      <CompanyEmployeeListItems
        :nextTo="nextTo"
        :nextIcon="nextIcon"
        :type="type"
        :emp="employees"
      ></CompanyEmployeeListItems>
    </template>
          <p class="mt-4">
        {{ $t("company.explanation") }}
      </p>
    <template v-if="type == 'instructor'">
      <div class="mt-4 d-flex">
        <div>
          <v-icon size="8" class="mt-n2">$sl-error</v-icon>
        </div>
        <p class="caption ml-2">{{ $t("company.max-appr-info") }}</p>
      </div>
      <div class="mt-n2 d-flex">
        <div>
          <v-icon size="8" class="mt-n2">$sl-triangle</v-icon>
        </div>
        <p class="caption ml-2">{{ $t("company.instruction-info") }}</p>
      </div>
    </template>
    <template
      v-if="
        $route &&
        $route.name &&
        $route.name != 'CompanyInstructorApprentices' &&
        $route.name != 'CompanyApprentices' &&
        $route.name != 'CompanyInstructors'
      "
    >
      <p class="overline small mt-8">{{ $t("company.legend") }}</p>
      <div class="d-flex caption mt-n2">
        <v-icon class="mr-2">$sl-admin</v-icon>
        <p class="caption mt-1">{{ $t("roles.adm") }}</p>
      </div>
      <div class="d-flex caption mt-n1" v-if="isDepartments">
        <v-icon class="mr-2">$sl-departments-admin</v-icon>
        <p class="caption mt-1">{{ $t("roles.avd") }}</p>
      </div>
      <div class="d-flex caption mt-n1">
        <v-icon class="mr-2">$sl-distance-admin</v-icon>
        <p class="caption mt-1">{{ $t("roles.dua") }}</p>
      </div>
      <div class="d-flex caption mt-n1">
        <v-icon class="mr-2">$sl-yua</v-icon>
        <p class="caption mt-1">{{ $t("roles.yua2") }}</p>
      </div>
      <div class="d-flex caption mt-n1">
        <v-icon class="mr-2">$sl-instructor</v-icon>
        <p class="caption mt-1">{{ $t("roles.hl2") }}</p>
      </div>
      <div class="d-flex caption mt-n1">
        <v-icon class="mr-2">$sl-apprentice</v-icon>
        <p class="caption mt-1">{{ $t("roles.lar") }}</p>
      </div>

      <v-btn
        fixed
        fab
        bottom
        right
        v-if="$route.name == 'CompanyEmployees'"
        class="elevation"
        color="primary"
        :disabled="isImitatingUser()"
        @click="
          $nextTick(() => {
            $router.push({
              name: 'CompanyNewEmployee',
              params: { id: $route.params.id },
            });
          })
        "
      >
        <v-icon>$sl-add</v-icon>
      </v-btn>
    </template>
    <template
      v-else-if="
        $route.name == 'CompanyApprentices' ||
        $route.name == 'CompanyInstructorApprentices'
      "
    >
      <p class="overline small mt-8">{{ $t("company.legend") }}</p>
      <div class="caption mt-n2">
        <p class="caption mt-1">{{ $t("company.GU") + ": " + $t("company.GU-desc") }}</p>
        <p class="caption mt-n3">{{ $t("company.KT") + ": " + $t("company.KT-desc") }}</p>
        <p class="caption mt-n3">
          <span class="darkgray caption text-capitalize">{{ $t("company.plan") }}</span
          >:
          {{ $t("company.plan-desc") }}
        </p>
      </div>
    </template>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import find from "lodash/find";
import uniq from "lodash/uniq";
import filter from "lodash/filter";
import { mapGetters } from "vuex";
import ActionButton from "@/components/Common/ActionButton";
import MessageBox from "@/components/Common/MessageBox.vue";
import CompanyEmployeeListItems from "@/components/Company/CompanyEmployeeListItems";
import CompanyEmployeeListDepartments from "@/components/Company/CompanyEmployeeListDepartments";
import { CompanyRoles } from "@/components/mixins";

// @group Company
// CompanyEmployeeList component
export default {
  name: "CompanyEmployeeList",

  mixins: [CompanyRoles],

  data() {
    return {
      links: require("../../lib/external-links.json"),
      employees: [],
      search: "",
      tab: null,
      workplace: null,
      workplaceChip: false,
      workplaceLabel: false,
    };
  },

  props: {
    tabId: {
      type: Number,
      default: 0,
    },
    isDepartments: {
      type: Boolean,
      default: false,
    },
    // list type
    type: {
      // `'String'`
      type: String,
      // 'all', 'apprentice', 'employed', 'instructor', 'companyEducationResponsible', 'distanceEducationAdministrator', 'administrator'
      default: "all",
    },
    //List title
    title: {
      // `'String'`
      type: String,
    },
    MessageBoxText: {
      type: String,
      default: "",
    },
    //Next icon prop
    nextIcon: {
      type: String,
      // `'String'`
      default: "$sl-arrow-right",
      // The default value is icon: `$sl-arrow-right`
    },
    //Next list
    nextTo: {
      // `'String'`
      type: String,
      // The default value is icon: `CompanyEmployee`
      default: "CompanyEmployee",
    },
    //Initial workplace
    initialWorkplace: {
      // `'NUmber'`
      type: Number,
      // The default value is icon: `Null`
      default: null,
    },
  },
  filters: {},

  components: {
    ActionButton,
    MessageBox,
    CompanyEmployeeListItems,
    CompanyEmployeeListDepartments,
  },
  computed: {
    ...mapGetters("currentuser", ["currentUser", "isAdministrator", "isImitatingUser"]),
  },
  watch: {
    tabId: {
      handler: function () {
        this.tab = this.tabId;
      },
      deep: true,
    },
  },

  created() {
    if (this.initialWorkplace) {
      this.workplace = this.initialWorkplace;
      this.workplaceChip = true;
      this.getWorkplaceName(this.workplace);
    }
    if (this.tabId && this.tabId > 0) {
      this.tab = this.tabId;
    }
    if (this.$route.params && this.$route.params.search) {
      this.search = this.$route.params.search;
    }
    this.fetchListData();
  },

  methods: {
    /**
     * @vuese
     * Used to fetch workplace
     * @arg The arguments are  integers value representing company id and workplace id
     */

    getWorkplaceName(wpId) {
      API.getWorkplace(this.$route.params.id, wpId)
        .then((response) => {
          this.workplaceLabel = response.data.name;
        })
        .catch((error) => {
          this.workplaceLabel = this.$t("fields.workplace");
        });
    },
    /**
     * @vuese
     * Used to cancel any operation
     */
    closeWorkplaceChip() {
      this.workplaceChip = false;
      this.workplace = null;
      this.fetchListData();
    },

    /**
     * @vuese
     * Used to fetch the list based on the type that is required
     * @arg The argument can be apprentice , employes list
     */
    fetchListData() {
      let apicall, params;
      let emp = this.currentUser.employments.find(
        (x) => x.companyId == this.$route.params.id
      );
      let options = { search: this.search, workplaceId: this.workplace };
      if (this.type === "myApprentices") {
        apicall = "listApprenticeships";
      } else {
        apicall = "listEmployments";
        options.type = this.type;
        params = this.$route.params.id;
      }

      this.employees = [];

      API[apicall](params, options)
        .then((response) => {
          if (this.isDepartments == true && this.type == "employed") {
            let empArray = [];
            response.data.forEach((r) => {
              if (r.departmentEmployments && r.departmentEmployments.length > 0) {
                r.departmentEmployments.forEach((e) => {
                  //let findDep = -1
                  if (this.isAdministrator == true) {
                    empArray.push(r);
                  } else if (
                    this.hasDepartmentId(emp, e.department.id) == true &&
                    r.isAdministrator != true
                  ) {
                    empArray.push(r);
                  }
                  else if(this.hasDepartmentIdForRole(emp, e.department.id, 'isDepartmentEducationResponsible') || this.hasDepartmentIdForRole(emp, e.department.id, 'isDepartmentDistanceEducationAdministrator'))
                  {
                    empArray.push(r)
                  }                  
                });
              } else {
                if (this.isAdministrator == true) {
                  empArray.push(r);
                } else if (r.isAdministrator != true) {
                  empArray.push(r);
                }
              }
            });
            this.employees = uniq(empArray, "id");
          } 
          else if (this.isDepartments == true && this.type == "apprentice") {
          let empArray = [];
            response.data.forEach((r) => { 
              if (r.workplaces && r.workplaces.length > 0) {
                r.workplaces.forEach((w) => {
                  w.workplaceaddress.departmentWorkplaces.forEach((e) => {
                    if (this.isAdministrator == true || this.hasDepartmentId(emp, e.department.id, false) == true) {
                      empArray.push(r);
                    }                  
                  })
                })
              }
            });
            this.employees = uniq(empArray, "id");
          }
          else if (this.isDepartments == true && this.type == "instructor") {
            let empArray = [];
            response.data.forEach((r) => {
              if (r.departmentEmployments && r.departmentEmployments.length > 0) {
                r.departmentEmployments.forEach((e) => {
                  // if (
                  //   this.isAdministrator == true ||
                  //   this.hasDepartmentId(emp, e.department.id, false) == true
                  // ) {
                  //   empArray.push(r);
                  // }                  
                  let findDep = -1;
                  if (e.isDepartmentInstructor == true) {
                    if (
                      this.isAdministrator == true ||
                      this.hasDepartmentId(emp, e.department.id, false) == true
                    ) {
                      empArray.push(r);
                    }                    
                  }
                });
              }
            });
            this.employees = uniq(empArray, "id");
          } else if (
            this.isDepartments == true &&
            this.type == "companyEducationResponsible"
          ) {
            let empArray = [];
            response.data.forEach((r) => {
              if (r.departmentEmployments && r.departmentEmployments.length > 0) {
                r.departmentEmployments.forEach((e) => {
                  let findDep = -1;
                  if (e.isDepartmentEducationResponsible == true) {
                    if (
                      this.isAdministrator == true ||
                      this.hasDepartmentId(emp, e.department.id, false) == true
                    ) {
                      empArray.push(r);
                    }                    
                  }
                });
              }
            });
            this.employees = uniq(empArray, "id");
          } else {
            this.employees = response.data;
          }
        })
        .catch((error) => {
          console.log("There was an error:", error);
        });
    },
  },
};
</script>

<style lang="scss"></style>
